import UnfilledButton from "@/components/common/unfilled-button";
import styles from "./undo-cancel-modal.module.scss";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { $undoCancelKey } from "@/data/undo-cancel.constants";
import { useABTestUndoCancelContext } from "@/providers/ab-testing-providers/ab-test-undo-cancel-provider";

const UndoCancelModal = () => {
  const { hideModal } = useGlobalModalContext();
  const router = useRouter();
  const { trackABConversion } = useABTestUndoCancelContext();

  const onClick = () => {
    trackABConversion();
    hideModal();
    router.push("/pricing");
  };

  useEffect(() => {
    localStorage.setItem($undoCancelKey, Date.now().toString());
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>Want to stick around?</div>
      <div className={styles.text}>
        Keep your membership going in one, easy step!
      </div>
      <UnfilledButton
        text={"UNDO CANCEL REQUEST"}
        textColor={"#f9a825"}
        borderColor={"#f9a825"}
        onClick={onClick}
      />
    </div>
  );
};

export default UndoCancelModal;
